
import { useState, useRef, useEffect, useContext } from 'react'

import styles from './intro_content.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'

import { AnnouncementContext } from './context/announcementContext'

function IntroContent(props) {
	const fields = props.fields
	const lineRef = useRef(null)
	const [visibleOut, setVisibleOut] = useState(0)
	const [scrollPos, setScrollPos] = useState(window.scrollY)
	const { announcementHeight, heightChangeHandler } = useContext(AnnouncementContext)

	const onScroll = () => {
		if ((lineRef.current.getBoundingClientRect().top + announcementHeight) < (window.outerHeight / 4)) {
			setVisibleOut(1)
		}

		setScrollPos(window.scrollY)
	}
	
	useEffect(() => {
		onScroll()
		window.addEventListener('scroll', onScroll)
		return () => window.removeEventListener('scroll', onScroll)
	}, [announcementHeight])

	return <BlockWrapper {...props} className={classNames(styles.intro_content, styles[fields.style])}>
		<ScrollAnimation styles={styles} reverse={true}>
			{fields.style == 'style_2' &&
				<div className={styles.overlay}></div>
			}
			<div ref={lineRef} className={classNames(styles.line, visibleOut ? styles.animate_out : '')}></div>
			<div className={styles.intro_content_wrapper}>
				<div className={styles.heading_wrapper}>
					<div className={styles.heading} dangerouslySetInnerHTML={{__html: fields.heading}}></div>
				</div>

				<div className={styles.content_wrapper}>
					<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>

					{(fields.button_clone.button?.title || fields.secondary_button.button?.title) &&
						<div className={styles.button_wrapper}>
							{fields.button_clone.button?.title &&
								<Button fields={{button: fields.button_clone.button, button_style: fields.button_clone.button_style, button_color: fields.button_clone.button_color}}>{fields.button_clone.button.title}</Button>
								// <Button fields={fields.button_clone} appearance='transparent' color={fields.style == 'style_1' ? 'black' : 'white'} className={styles.button}>{fields.button_clone.button.title}</Button>
							}

							{fields.secondary_button.button?.title &&
								<Button fields={{button: fields.secondary_button.button, button_style: fields.secondary_button.button_style}} className={styles.secondary_button}>{fields.secondary_button.button.title}</Button>
							}
						</div>
					}
				</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default IntroContent